import { ChangeDetectionStrategy, Component, OnInit, input, inject, signal } from '@angular/core';
import { DOCUMENT_LINKS } from '@bazis/configuration.service';
import { CookieService } from 'ngx-cookie-service';
import { ButtonModule } from '@bazis/shared/components/web/button/button.module';
import { IconModule } from '@bazis/shared/components/web/icon/icon.module';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';
import { ColorDirective } from '@bazis/shared/directives/color.directive';
import { BazisContextMenuService } from '@bazis/shared/services/context-menu.service';

@Component({
    selector: 'bazis-cookie',
    templateUrl: './cookie.component.html',
    imports: [ButtonModule, IconModule, CommonModule, TranslocoModule, ColorDirective],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CookieComponent implements OnInit {
    public cookieService = inject(CookieService);

    readonly link = input(DOCUMENT_LINKS.cookiePolicy);

    readonly showCookie = signal(false);

    ngOnInit(): void {
        this.calculateCookie();
    }

    accept() {
        this.cookieService.set('cookieAccepted', 'true');
        this.calculateCookie();
    }

    calculateCookie() {
        this.showCookie.set(!this.cookieService.get('cookieAccepted'));
    }
}
